import React from 'react';

type Props = {
  onPrev: () => void;
  onNext: () => void;
  disablePrev?: boolean;
  disableNext?: boolean;
};

const CarouselControls = ({
  onPrev,
  onNext,
  disablePrev = false,
  disableNext = false,
}: Props) => {
  return (
    <div className="flex justify-center gap-3">
      <button
        type="button"
        onClick={onPrev}
        disabled={disablePrev}
        className="bg-surface-light text-theme-brand-blue flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg transition disabled:cursor-not-allowed disabled:opacity-50"
        aria-label="Previous"
      >
        ←
      </button>

      <button
        type="button"
        onClick={onNext}
        disabled={disableNext}
        className="bg-surface-light text-theme-brand-blue flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg transition disabled:cursor-not-allowed disabled:opacity-50"
        aria-label="Next"
      >
        →
      </button>
    </div>
  );
};

export default CarouselControls;
